import { useApi } from "lib/apiFetcher";

//@ts-ignore
export const usePostContactBusiness = () => useApi("post", "/tenants/business-contact");